import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filterButton", "filterTypeField", "exhibitorCards", "searchInput"]
  static values = { 
    activeFilter: String,
    favoriteUrl: String,
    exhibitorFilterUrl: { type: String, default: "/attendee/dashboard/favourite_exhibitors" },
    switchEventUrl: { type: String, default: "/attendee/dashboard/switch_event" }
  }

  connect() {
    this.activeFilterValue = this.activeFilterValue || 'all'
    this.debounceTimeout = null
    this.abortController = null
    this.currentAbortController = null
  }

  disconnect() {
    if (this.abortController) {
      this.abortController.abort()
    }
    
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  switchEvent(event) {
    const eventId = event.params.eventId
    window.location.href = `${this.switchEventUrlValue}?event_id=${eventId}`
  }

  filterExhibitors(event) {
    const filterType = event.params.filter
    
    // Update hidden field
    this.filterTypeFieldTarget.value = filterType
    
    // Update tab states
    this.filterButtonTargets.forEach(button => {
      const buttonFilter = button.dataset.filter
      if (buttonFilter === filterType) {
        button.classList.add('active')
      } else {
        button.classList.remove('active')
      }
    })

    // Get search term and trigger search
    const searchTerm = this.searchInputTarget?.value || ''
    this.searchWithDebounce(searchTerm, filterType)
  }

  search(event) {
    const currentFilter = this.filterTypeFieldTarget.value || 'all'
    const searchTerm = event.target.value
    
    this.searchWithDebounce(searchTerm, currentFilter)
  }

  searchWithDebounce(searchTerm, filterType) {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
    
    this.debounceTimeout = setTimeout(() => {
      this.fetchFilteredExhibitors(filterType, searchTerm)
    }, 300)
  }

  fetchFilteredExhibitors(filterType, searchTerm) {
    // Cancel previous request
    if (this.abortController) {
      this.abortController.abort()
    }
    
    // Create new AbortController and track it
    this.abortController = new AbortController()
    
    const params = new URLSearchParams({
      filter_type: filterType,
      search: searchTerm
    })

    fetch(`${this.exhibitorFilterUrlValue}?${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: this.abortController.signal
    })
    .then(response => {
      if (response.status === 401) {
        const redirectUrl = document.querySelector('meta[name="admin-user-key"]') 
          ? '/admin/dashboard' 
          : '/attendee/sessions/new'
        window.location.href = redirectUrl
        return
      }
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }
      
      return response.text()
    })
    .then(html => {
      if (html && this.hasExhibitorCardsTarget) {
        this.exhibitorCardsTarget.innerHTML = html
      }
    })
    .catch(error => {
      if (error.name !== 'AbortError') {
        console.error('Error filtering exhibitors:', error)
      }
    })
    .finally(() => {
      if (this.abortController && this.abortController !== this.currentAbortController) {
        this.currentAbortController = null
      }
    })
  }
}
